import { KLineData } from "klinecharts";
import { readStyle } from "./indicatorUtils";

export const createBullsPower = (settings: any) => {
  const values = settings?.values ?? {};
  const styles = settings?.styles ?? settings?.styleSettings ?? {};
  const period = (values.Period as number) ?? 13;
  const valS = readStyle(styles, "value", "#26A69A");

  return {
    name: "bulls-power",
    shortName: "Bulls",
    calcParams: [period],
    series: "normal" as const,
    figures: [{ key: "value", title: `Bulls${period}: `, type: "bar" }],
    styles: {
      bars: [
        {
          upColor: valS.color,
          downColor: valS.color,
          noChangeColor: valS.color,
        },
      ],
    },
    regenerateFigures: ([p]: number[]) => [
      { key: "value", title: `Bulls${p}: `, type: "bar" },
    ],
    calc: (dataList: KLineData[], indicator: { calcParams?: unknown[] }) => {
      const [p] = (indicator.calcParams ?? [period]) as [number];
      const n = dataList.length;
      const results: Array<{ value?: number }> = new Array(n);
      const k = 2 / (p + 1);
      let ema = 0;

      for (let i = 0; i < n; i++) {
        const c = dataList[i]!.close;
        if (i === 0) ema = c;
        else ema = (c - ema) * k + ema;
        if (i >= p - 1) {
          results[i] = { value: dataList[i]!.high - ema };
        } else {
          results[i] = {};
        }
      }

      return results;
    },
  };
};
